<template>
  <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.1273 4C10.1273 6.20914 8.33648 8 6.12734 8C3.91821 8 2.12734 6.20914 2.12734 4C2.12734 1.79086 3.91821 0 6.12734 0C8.33648 0 10.1273 1.79086 10.1273 4Z"
      fill="#9CA3AF"
    />
    <path
      d="M0.507812 14.4593C0.507812 11.7756 2.57319 9.6 6.10781 9.6L-nan -nanL6.10781 9.6C9.64244 9.6 11.7078 11.7756 11.7078 14.4593V14.72C11.7078 15.4269 10.953 16 10.022 16H2.19367C1.2626 16 0.507812 15.4269 0.507812 14.72V14.4593Z"
      fill="#9CA3AF"
    />
    <path
      d="M13.8349 0.881076C14.0271 0.560474 14.5076 0.560475 14.6998 0.881077L16.4397 3.78327C16.6319 4.10387 16.3916 4.50462 16.0072 4.50462H12.5275C12.143 4.50462 11.9028 4.10387 12.095 3.78327L13.8349 0.881076Z"
      fill="#9CA3AF"
    />
    <path
      d="M12.4007 6.5883C12.4007 6.3521 12.5949 6.16062 12.8346 6.16062H15.7001C15.9398 6.16062 16.134 6.3521 16.134 6.5883V9.41295C16.134 9.64915 15.9398 9.84062 15.7001 9.84062H12.8346C12.5949 9.84062 12.4007 9.64915 12.4007 9.41295V6.5883Z"
      fill="#9CA3AF"
    />
    <path
      d="M14.0302 11.0237C14.1716 10.9183 14.3631 10.9183 14.5044 11.0237L16.341 12.394C16.4824 12.4995 16.5416 12.6865 16.4876 12.8572L15.7861 15.0744C15.7321 15.2451 15.5772 15.3606 15.4024 15.3606H13.1323C12.9575 15.3606 12.8026 15.2451 12.7486 15.0744L12.0471 12.8572C11.9931 12.6865 12.0523 12.4995 12.1937 12.394L14.0302 11.0237Z"
      fill="#9CA3AF"
    />
  </svg>
</template>
